function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

// Function to get a cookie by name
function getCookie(name) {
  let nameEQ = name + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function checkAlert(alert, alertID, alertKey) {
  if (getCookie(alertID) != alertKey) {
    alert.style.display = 'block';
  }
}

function closeAlert(alert, alertID, alertKey) {
  alert.style.display = 'none';
  setCookie(alertID, alertKey, 14);
}

function inPageAlert() {
  const inPageAlerts = document.querySelectorAll('.in-page-alert .alert');

  if (!inPageAlerts.length > 0) return;

  inPageAlerts.forEach((alert) => {
    const closeButton = alert.querySelector('.close-alert');
    const alertID = alert.getAttribute('data-id');
    const alertKey = alert.getAttribute('data-key');

    closeButton.addEventListener('click', () => {
      closeAlert(alert, alertID, alertKey);
    });
    checkAlert(alert, alertID, alertKey);
  });
}

function handleInPageAlertPosition() {
  const inPageAlertMobilePlaceholder = document.querySelector('.in-page-alert-mobile-placeholder');
  const inPageAlertDesktopPlaceholder = document.querySelector('.in-page-alert-desktop-placeholder');
  const inPageAlertElement = document.querySelector('.in-page-alert');
  const breakpoint = window.matchMedia('(min-width: 992px)');

  if (!inPageAlertMobilePlaceholder || !inPageAlertElement  || !inPageAlertDesktopPlaceholder) return;

  function setAlertPosition() {
    if (!breakpoint.matches) {
      inPageAlertMobilePlaceholder.appendChild(inPageAlertElement);
    } else {
      inPageAlertDesktopPlaceholder.appendChild(inPageAlertElement);
    }
  }

  setAlertPosition();

  breakpoint.addEventListener('change', setAlertPosition);

}

window.addEventListener('load', () => {
  inPageAlert();
  handleInPageAlertPosition();
});
